export default __webpack_public_path__ + "static/media/signal-graph.7abcdd7b.svg";